import { ScrollbarOptions } from 'smooth-scrollbar/interfaces';

export const scrollbarOptions: ScrollbarOptions = {
  damping: 0.2,
  thumbMinSize: 20,
  renderByPixels: true,
  alwaysShowTracks: false,
  continuousScrolling: true,
  wheelEventTarget: null,
  plugins: null,
  delegateTo: null
};
